/* eslint-disable import/no-anonymous-default-export */
import { useEffect, useState } from "react";
import useFacility from "../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../../app/store";

export const PARK_WODNY = "1241";
export const FIT_PARK = "1243";

export const PARK_WODNY_LOGO = "https://panel.eaktywni.pl/img/1241/parkwodny_nav.jpg";
export const FIT_PARK_LOGO = "https://panel.eaktywni.pl/img/1243/fitpark_nav.jpg";

export default () => {
  const facilityIds = useFacility();
  const [imageUrl, setImageUrl] = useState("");
  const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);

  useEffect(() => {
    if (facilityIds === FIT_PARK) {
      setImageUrl(FIT_PARK_LOGO);
    } else if (facilityIds === PARK_WODNY) {
      setImageUrl(PARK_WODNY_LOGO);
    } else {
      setImageUrl(logoUrl);
    }
    //eslint-disable-next-line
  }, [facilityIds]);

  return {
    imageUrl,
    setImageUrl,
  };
};
